import { Injectable } from '@angular/core';
/**
 * Configuration service, provides default values for the AccordionComponent.
 */
var AccordionConfig = (function () {
    function AccordionConfig() {
        /** Whether the other panels should be closed when a panel is opened */
        this.closeOthers = false;
    }
    AccordionConfig.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    AccordionConfig.ctorParameters = function () { return []; };
    return AccordionConfig;
}());
export { AccordionConfig };
//# sourceMappingURL=accordion.config.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/accordion/accordion.config.js
// module id = 223
// module chunks = 3